import { render, staticRenderFns } from "./ModalInquiryReturn.vue?vue&type=template&id=9f2b790a&"
import script from "./ModalInquiryReturn.vue?vue&type=script&lang=js&"
export * from "./ModalInquiryReturn.vue?vue&type=script&lang=js&"
import style0 from "./ModalInquiryReturn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports